import { DataProxy } from "./dataproxy";
import { IFilterCallback, IFilterMode, IDataCollection, ITreeCollection, DataDriver, IDataDriver } from "./types";

import { IAnyObj } from "@dhx/ts-common/types";
import { dataDrivers } from "./drivers/drivers";

export function isEqualObj(a: any, b: any) {
	for (const key in a) {
		if (a[key] !== b[key]) {
			return false;
		}
	}
	return true;
}
export function naturalCompare(a, b) {
	if (isNaN(a) || isNaN(b)) {
		const ax = [];
		const bx = [];

		a.replace(/(\d+)|(\D+)/g, (_, $1, $2) => {
			ax.push([$1 || Infinity, $2 || ""]);
		});
		b.replace(/(\d+)|(\D+)/g, (_, $1, $2) => {
			bx.push([$1 || Infinity, $2 || ""]);
		});

		while (ax.length && bx.length) {
			const an = ax.shift();
			const bn = bx.shift();
			const nn = (an[0] - bn[0]) || an[1].localeCompare(bn[1]);
			if (nn) {
				return nn;
			}
		}

		return ax.length - bx.length;
	}

	return a - b;
}

export function findByConf(item: any, conf: IFilterMode | IFilterCallback): any {
	if (typeof conf === "function") {
		if (conf.call(this, item)) {
			return item;
		}
	} else if (conf.by && conf.match) {
		if (item[conf.by] === conf.match) {
			return item;
		}
	}
}

export function isDebug(): boolean {
	const dhx = (window as any).dhx;
	if (typeof dhx !== "undefined") {
		return typeof (dhx.debug) !== "undefined" && dhx.debug;
	}
	// return typeof DHX_DEBUG_MODE !== "undefined" && DHX_DEBUG_MODE;
}
export function dhxWarning(msg: string) {
	// tslint:disable-next-line:no-console
	console.warn(msg);
}
export function dhxError(msg: string) {
	throw new Error(msg);
}

export function toProxy(proxy: any): DataProxy {
	const type = typeof proxy;

	if (type === "string") {
		return new DataProxy(proxy);
	} else if (type === "object") {
		return proxy;
	}
}
export function toDataDriver(driver: DataDriver | IDataDriver) {
	if (typeof driver === "string") {
		const dhx = (window as any).dhx;
		const drivers = (dhx && dhx.dataDrivers) || dataDrivers;

		if (drivers[driver]) {
			return new drivers[driver]();
		} else {
			// tslint:disable-next-line:no-console
			console.warn("Incorrect data driver type:", driver);
			// tslint:disable-next-line:no-console
			console.warn("Available types:", JSON.stringify(Object.keys(drivers)));
		}
	} else if (typeof driver === "object") {
		return driver;
	}
}

export function copyWithoutInner(obj: IAnyObj, forbidden?: IAnyObj): IAnyObj {
	const result = {};
	for (const key in obj) {
		if (key[0] !== "$" && (!forbidden || !forbidden[key])) {
			result[key] = obj[key];
		}
	}
	return result;
}

export function isTreeCollection(obj: IDataCollection<any> | ITreeCollection<any>): obj is ITreeCollection<any> {
	return Boolean((obj as ITreeCollection).getRoot);
}

export function hasJsonOrArrayStructure(str: any): boolean {
	if (typeof str === "object") { return true; }
	if (typeof str !== "string") { return false; }
	try {
		const result = JSON.parse(str);
		return Object.prototype.toString.call(result) === "[object Object]"
			|| Array.isArray(result);
	} catch (err) {
		return false;
	}
}